import apiInstance from "api";

export const UserQuotationApiService = {
  getQuotations: async (filters) => {
    return await apiInstance.get("/quotations", {
      params: {
        ...filters,
      },
    });
  },
  getQuotation: async (quotationId) => {
    return await apiInstance.get(`/quotations/${quotationId}`);
  },
  acceptQuotation: async (quotationId) => {
    return await apiInstance.post(`/quotations/${quotationId}/accept`);
  },
  confirmWithPO: async (quotationId, data) => {
    return await apiInstance.post(`/quotations/${quotationId}/confirm-po`, data);
  },
  payOnline: async (quotationId) => {
    return await apiInstance.post(`/quotations/${quotationId}/pay-online`);
  },
  checkout: async (quotationId, data) => {
    return await apiInstance.post(`/quotations/${quotationId}/checkout`, data);
  },
};
